const destructureTime = (totalSeconds: number) => {
  totalSeconds = Math.floor(totalSeconds);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds - hours * 3600) / 60);
  const seconds = totalSeconds - hours * 3600 - minutes * 60;

  return {
    hours,
    minutes,
    seconds
  };
};

export const TimeFormat = (totalSeconds: number, format?: string) => {
  const { hours, minutes, seconds } = destructureTime(totalSeconds);
  if (!format) {
    return `${hours > 0 ? `${hours} : ` : ''}${minutes}:${seconds}`;
  }
  return format.replace(/HH|hh|MM|mm|SS|ss/g, match => {
    switch (match) {
      case 'HH':
        return hours.toString().padStart(2, '0');
      case 'hh':
        return hours.toString();
      case 'MM':
        return minutes.toString().padStart(2, '0');
      case 'mm':
        return minutes.toString();
      case 'SS':
        return seconds.toString().padStart(2, '0');
      case 'ss':
        return seconds.toString();
      default:
        return match;
    }
  });
};
